import { render, staticRenderFns } from "./io-viewer.vue?vue&type=template&id=4cd5b22e"
import script from "./io-viewer.vue?vue&type=script&lang=js"
export * from "./io-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports